import type { FC } from 'react';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';
import { cn } from '@src/design-system/helpers';
import HostItem from './components/host-item';

const HostCustomFields: FC<{
  host: TPlacementHostCompany;
  modal?: boolean;
}> = ({ host, modal = true }) => {
  return (
    <div
      className={cn(
        'space-y-4 p-4 m-4 mt-0 bg-white rounded-xl',
        !modal && 'm-0 p-0'
      )}
    >
      <p className='font-semibold text-gray-800'>Custom Fields</p>
      <div
        className={cn(
          'grid gap-3',
          modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3'
        )}
      >
        {host?.custom_fields?.map((customField) => {
          const values = customField.value?.value?.filter(Boolean) ?? [];
          const formattedValue = values.length ? values.join(', ') : '-';

          return (
            <HostItem
              key={customField.id}
              label={customField.label}
              value={formattedValue}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HostCustomFields;
